module.exports = __webpack_public_path__ + "img/propertyIndexTab2.e7b0d9ed.png";